import { CalendarX2 } from "lucide-react";
import { Modal } from "../shared/Modal";

export const EXPIRED_DEADLINE_MESSAGE =
  "O direito legal de arrependimento sem custos e estorno integral (Art. 49 do CDC e Lei nº 13.786/18) é estritamente limitado a 7 dias corridos a partir da assinatura. Como seu contrato ultrapassou esse prazo decadencial, a notificação extrajudicial tempestiva não é mais aplicável. Recomendamos a consulta a um advogado especialista em direito imobiliário.";

interface Props {
  open: boolean;
  days: number;
  onReview: () => void;
}

export function ExpiredDeadlineModal({ open, days, onReview }: Props) {
  return (
    <Modal
      open={open}
      onClose={onReview}
      testId="deadline-expired-modal"
      title="Prazo decadencial ultrapassado"
      icon={
        <span className="flex h-11 w-11 items-center justify-center rounded-md border border-amber-500/30 bg-amber-500/10">
          <CalendarX2 aria-hidden="true" className="h-5 w-5 text-amber-400" />
        </span>
      }
      footer={
        <button type="button" onClick={onReview} data-testid="deadline-modal-review-button" className="btn-primary">
          Revisar data
        </button>
      }
    >
      <p data-testid="deadline-modal-message">{EXPIRED_DEADLINE_MESSAGE}</p>
      <p data-testid="deadline-modal-days" className="mt-4 font-mono text-xs uppercase tracking-[0.16em] text-slate-500">
        Dias corridos desde a assinatura: D+{days}
      </p>
    </Modal>
  );
}
